export default __webpack_public_path__ + "static/media/info_bonus.min.23b9b3da.png";